import classes from './ProductCard.module.css.mjs';

const productCardDetailsClasses = {
  "Product Card": classes.productCardDetailsWrapper,
  "Product List Slider": classes.productListSliderDetailsWrapper,
  "Shop The Room": classes.shopTheRoomDetailsWrapper,
  "Account Card": classes.accountCardDetailsWrapper
};
const productCardDetailsRightSectionClasses = {
  "Product Card": classes.productCardDetailsRightProductCard,
  "Product List Slider": classes.productCardDetailsRightAccountSlider,
  "Account Card": classes.productCardDetailsRightAccountSlider
};
const productCardPriceClasses = {
  "Product Card": classes.productCardSecondaryText,
  "Product List Slider": classes.productCardPrimaryText,
  "Shop The Room": classes.productCardPrimaryText,
  "Account Card": classes.productCardTertiaryText
};
const productCardSlashedPriceClasses = {
  "Product Card": classes.productCardTertiaryText,
  "Product List Slider": classes.productCardSecondaryText,
  "Shop The Room": classes.productCardTertiaryText,
  "Account Card": classes.productCardTertiaryText
};
const productCardDetailsSpacingClasses = {
  "Product Card": classes.productCardDetailsContainer50,
  "Product List Slider": classes.productCardDetailsContainer70,
  "Shop The Room": classes.productCardDetailsContainer50,
  "Account Card": classes.productCardDetailsContainer20
};

export { productCardDetailsClasses, productCardDetailsRightSectionClasses, productCardDetailsSpacingClasses, productCardPriceClasses, productCardSlashedPriceClasses };
